import styled from 'styled-components';
import {ImageSize} from '../enums/ImageSize';
import {LazyLoadImage} from 'react-lazy-load-image-component';

const Wrapper = styled.div`
  overflow: hidden;
`

const StyledLazyLoadImage = styled(LazyLoadImage)`
  display: flex !important;
  object-fit: cover;
  max-width: none;

  &:not(.lazy-load-image-loaded) img {
    display: none;
  }

  &.small {
    width: var(--cr-image-size-small);
    height: var(--cr-image-size-small);
  }

  &.large {
    width: var(--cr-image-size-large);
    height: var(--cr-image-size-large);
  }
`

type TProps = {
    src?: string;
    placeholderSrc?: string;
    alt: string;
    size: ImageSize;
}

const ImageBlock = ({src, placeholderSrc, alt, size = ImageSize.Small}: TProps) => {
    return (
        <Wrapper className={'cr-rounded-block cr-flex'}>
            <StyledLazyLoadImage
                className={`cr-rounded-block ${size}`}
                alt={alt}
                src={src ?? undefined}
                placeholderSrc={placeholderSrc}
                effect={src ? 'blur' : undefined}
            />
        </Wrapper>
    );
}

export default ImageBlock;
